var getMouseX = function (e) {
    var target = e.currentTarget;
    var bounds = target.getBoundingClientRect();
    return e.clientX - bounds.left;
};
export default getMouseX;
